import
{
  ClubLogoContainer,
} from './ClubLogoAvatar.styles';
import DefaultBadge from '../../../assets/images/default-badge.png';
import { Skeleton } from '@mui/material';

const ClubLogoAvatar = ({ clubLogo, small }) =>
{
  return (
    <>
      {
        (clubLogo === "loading") ?
          <Skeleton variant="circular">
            <ClubLogoContainer />
          </Skeleton>
          :
          <ClubLogoContainer
            logo={clubLogo ? clubLogo : DefaultBadge}
            small={small ? 'true' : undefined}
          />
      }
    </>
  );
};

export default ClubLogoAvatar;
